module.exports = __webpack_public_path__ + "static/media/bumppy_wallet.2f049a46.svg";